import { CmsModuleComponent } from '../cms-module-component.model';
import { PushCardComponentInterface } from './push-card.interface';
import { Wrapper } from '../wrapper.model';

export interface PushCardPanelComponentInterface extends CmsModuleComponent, Wrapper {
  layout?: string;
  componentsObjects?: PushCardComponentInterface[];
}

export enum PushPanelConfigEnum {
  RIGHT = 'VERTICAL_CARD_RIGHT',
  LEFT = 'VERTICAL_CARD_LEFT'
}
